import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

export const MergeabilityFailureIcon: Icon = ({className = '', ...props}) => (
  <CustomIcon
    {...props}
    className={`octicon-mergeability-failure ${className}`.trim()}
    naturalWidth={12}
    naturalHeight={12}
  >
    <path d="M2.293 3.707a1 1 0 0 1 1.414-1.414L6 4.586l2.293-2.293a1 1 0 1 1 1.414 1.414L7.414 6l2.293 2.293a1 1 0 0 1-1.414 1.414L6 7.414 3.707 9.707a1 1 0 0 1-1.414-1.414L4.586 6Z" />
  </CustomIcon>
)
